// extracted by mini-css-extract-plugin
module.exports = {"socialMediaContainer":"socialMediaIcons-module--socialMediaContainer--3j7Wf"};